"use client";

import type { ReactNode } from "react";
import { useLazyMount } from "@/hooks/useLazyMount";

/**
 * Wraps a below-fold section so it doesn't mount (and doesn't run its
 * effects — GSAP ScrollTriggers, Framer Motion springs, etc.) until it's
 * within `rootMargin` of the viewport. See useLazyMount for why this is
 * necessary on top of next/dynamic.
 */
export default function LazySection({
  children,
  fallback,
  rootMargin = "600px",
}: {
  children: ReactNode;
  fallback: ReactNode;
  rootMargin?: string;
}) {
  const { ref, shouldMount } = useLazyMount(rootMargin);
  return <div ref={ref}>{shouldMount ? children : fallback}</div>;
}
